import { sortDateString } from '@components/Table/utils/sortDateString';
import {
  createTableColumnsV2,
  TableColumns,
} from '@components/TableV2/helpers/createTableColumnsV2';
import { Translate } from '@hooks/useI18n';
import { IApplicationDocumentData } from '../../types';

export const getApplicationDocumentsColumns = (translate: Translate) => {
  const columns: TableColumns<IApplicationDocumentData> = [
    {
      field: 'created',
      label: translate('LABEL.UPLOAD_DATE'),
      sortable: true,
      sortComparator: sortDateString,
    },
    {
      field: 'type',
      label: translate('TITLE.DOCUMENT_TYPE'),
    },
    {
      field: 'fileName',
      label: translate('LABEL.FILE_NAME'),
    },
    // TODO - HC-16447 add button to download document
    // {
    //   field: 'uuid',
    //   label: '',
    //   mapCustomJSX: ({ row }) => {
    //     return (
    //       <Box display="flex" justifyContent="flex-end" width={'100%'}>
    //         <Button
    //           onClick={() => handleClick(row.uuid)}
    //           variant={[ButtonVariant.Primary, ButtonVariant.Sm]}
    //         >
    //           {translate('BUTTON.DOWNLOAD')}
    //         </Button>
    //       </Box>
    //     );
    //   },
    // },
  ];

  return createTableColumnsV2({ columns });
};
